export default "__VITE_ASSET__9b513ee9__"